// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1t0o9","info":"PatientInfo_info__XzNRi"};